import { AnimatePresence } from "framer-motion";
import { useSystemMessage } from "../../providers/SystemMessageContext";
import { ToastWrapper } from "../popups/Toast/ToastWrapper";

export const SystemMessagePopup = () => {
  const { messages, hideMessage } = useSystemMessage();

  return (
    <AnimatePresence>
      {messages.map((msg, index) => (
        <ToastWrapper
          key={msg.id}
          id={msg.id}
          text={msg.text}
          severity={msg.severity}
          index={index}
          onClose={hideMessage}
        />
      ))}
    </AnimatePresence>
  );
};

